export const SS_BACK_TO_PROJECT_PRESENTATION = "presentation-back-project-id";
